import React, { Component } from 'react';
import shortid from "shortid";

class FaqListComponent extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (
            <div className="informational-faq-item">
                <dl>
                    <div key={shortid.generate()}>
                        <dt className="informational-faq--question" onClick={this.props.toogleActiveAcordionTab} dangerouslySetInnerHTML={{ "__html": this.props.faq.Question.Value }} />
                        <dd className="informational-faq--answer" dangerouslySetInnerHTML={{ "__html": this.props.faq.Answer.Value }} />
                    </div>
                </dl>
            </div>
        )
    }
}

export default FaqListComponent;